import { allImages } from "../../services/images";
import { Heading } from "../../components/Reusable/resuable";
import { useAppSelector } from "../../Redux/hook";
import { FlippingCards } from "../../components/Reusable/resuable";
import { blogs } from "../../services/data";
import { useEffect,useRef } from "react";
import { Helmet } from "react-helmet-async";
import './blog.scss';
export default function Blog() {
    const lightMode = useAppSelector((state) => state.mode.lightMode);   
    const sectionref=useRef<HTMLDivElement|null>(null);
    useEffect(()=>{
        const timer=setTimeout(()=>{
            sectionref.current?.scrollIntoView({behavior:"smooth",block:"center"});
        },2000);
        return ()=>clearTimeout(timer);
    },[]) 
    return (
        <div className="blog">
            <Helmet>
                <title>Projects - PBL Transport</title>
            </Helmet>
            <div className="banner">
                <div className="content">
                    <div>Your Guide to</div>
                    <div>Choosing Reliable</div>
                    <div>Transport Services</div>
                </div>
                <img src={allImages.blog} alt="blog" />
            </div>
            <div ref={sectionref}></div>
            <Heading heading="Our Latest Projects" lightMode={lightMode} />
            <div className="blogs">
                {
                    blogs===undefined?<div/>:blogs.map((item,i)=>{
                        return <FlippingCards key={i} {...item}/>})
                }
            </div>
        </div>
    )
}